import PF001 from './PF/PF001'
import PF041 from './PF/PF041'
import PF137 from './PF/PF137'
import FM046 from './FM/FM046'
import FM051 from './FM/FM051'
import OP003 from './OP/OP003'
import OP028 from './OP/OP028'
import OP055 from './OP/OP055'
import OP060 from './OP/OP060'
import OP064 from './OP/OP064'
import OP065 from './OP/OP065'
import OP067 from './OP/OP067'
import OP070 from './OP/OP070'
import OP073 from './OP/OP073'
import OP074 from './OP/OP074'
import OP085 from './OP/OP085'
import OP087 from './OP/OP087'
import OP094 from './OP/OP094'
import OP095 from './OP/OP095'
import OP142 from './OP/OP142'

export default {
  PF001,
  PF041,
  PF137,
  FM046, // 跑批任务
  FM051,
  OP003,
  OP028,
  OP055,
  OP060,
  OP064,
  OP065,
  OP067,
  OP070,
  OP073,
  OP074,
  OP085,
  OP087,
  OP094,
  OP095,
  OP142,
}